import { render, staticRenderFns } from "./crsInfo2.vue?vue&type=template&id=3274bf6c"
import script from "./crsInfo2.vue?vue&type=script&lang=js"
export * from "./crsInfo2.vue?vue&type=script&lang=js"
import style0 from "./crsInfo2.vue?vue&type=style&index=0&id=3274bf6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports